<div *ngIf="results.totalRecordCount === 0">

  <div class="main-container std-results">
    <div class="container">
      <div class="row">

        <div class="no-results">
          <div class="inner">
            <div class="image">
              <img src="assets/img/no-sites.png" alt="" />
            </div>
            <div class="content">
              <h2>No Expense Categories, Yet</h2>
              <p>Your created expense categories will appear here.</p>

              @if (authService.hasPermission(Permissions.ExpenseCategoryAdd)) {
                <app-button text="+ Add New Category" href="/category/add" />
              }
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>

<div *ngIf="results.totalRecordCount > 0">

  <div class="view-head">
    <div class="row">
      <div class="col-12 d-none d-lg-block col-lg-6">
        <h2>Expense Categories</h2>
      </div>

      <div class="col-12 col-lg-6 text-right">
        <div class="button-container">
          @if (authService.hasPermission(Permissions.ExpenseCategoryAdd)) {
            <app-button text="+ Add New Category" href="/category/add" />
          }
        </div>
      </div>
    </div>
  </div>

  <div class="view-body">
    <div class="content-panel">
      <table class="std-results-list">
        <tbody>
        <tr data-toggle-class="more-btn" *ngFor="let category of results.results">
          <td> {{ category.name }}</td>
          <td class="action-buttons-cell">
            <div class="action-buttons">
              @if (authService.hasPermission(Permissions.ExpenseCategoryDelete) && category.canDelete) {
                <app-button text="Delete" (clicked)="onDeleteCategory(category.id)" variant="info" size="sm" />
              }

              @if (authService.hasPermission(Permissions.ExpenseCategoryEdit)) {
                <app-button text="Edit" href="/category/{{ category.id }}/edit" variant="secondary" size="sm" />
              }
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <app-pagination [currentPage]="results.currentPage" [totalPageCount]="results.totalPageCount" (pageSelected)="loadCategories($event)"></app-pagination>
    </div>
  </div>

</div>

<!-- Start: Delete category modal -->
<app-modal #deleteCategoryModal>
  <div class="modal-header">
    <h2 class="modal-title">Delete Expense Category?</h2>
  </div>
  <div class="modal-body text-center">
    <div class="delete-modal-text">
      <p>Are you sure you want to delete this category?</p>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel"
                    (clicked)="deleteCategoryModal.hide()"
                    variant="secondary"
                    width="fill" />
      </div>

      <div class="col-6">
        <app-button text="Yes, delete"
                    (clicked)="onConfirmDeleteCategory()"
                    [isBusy]="categoryIsDeleting"
                    [disabled]="categoryIsDeleting"
                    width="fill" />
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Delete category modal -->
